import { safeDecodeBase64Json } from "./safeDecodeBase64Json";

export interface ParsedHubTokenInfo {
  type: "packages" | "catalogs";
  count: number;
}

export function parseHubTokenKey(
  tokenKey: string | null | undefined,
): ParsedHubTokenInfo | null {
  if (!tokenKey?.trim()) return null;

  const decodedJson = safeDecodeBase64Json<Record<string, unknown>>(
    tokenKey.trim(),
  );
  if (!decodedJson) return null;

  let reqJson: Record<string, unknown> | null = null;
  if (
    decodedJson.featureConfig &&
    typeof (decodedJson.featureConfig as Record<string, unknown>).Features ===
      "string"
  ) {
    try {
      reqJson = JSON.parse(
        (decodedJson.featureConfig as Record<string, unknown>)
          .Features as string,
      );
    } catch {
      // ignore
    }
  } else if (decodedJson.exportRequestJson) {
    try {
      reqJson = JSON.parse(decodedJson.exportRequestJson as string);
    } catch {
      // ignore
    }
  }

  if (reqJson) {
    // Handle packages payload
    if (reqJson.packages && Array.isArray(reqJson.packages)) {
      return { type: "packages", count: reqJson.packages.length };
    }

    // Handle catalogs payload
    if (reqJson.catalogs && Array.isArray(reqJson.catalogs)) {
      return { type: "catalogs", count: reqJson.catalogs.length };
    }
  }

  return null;
}
